import { ApolloError } from '@apollo/client';
import React from 'react';
import { UseFormReturn, useFormContext } from 'react-hook-form';

export const useSetFormError = (fn: () => Promise<void>): (() => Promise<void>) => {
  const { setError } = useFormContext();
  return async (): Promise<void> => {
    try {
      await fn();
    } catch (e) {
      const error = e as ApolloError;

      const errorMessage =
        error.graphQLErrors && error.graphQLErrors[0]
          ? error.graphQLErrors[0].message
          : error.message;

      setError('_', { type: 'error', message: errorMessage });
    }
  };
};

export const WithSetFormError: React.FC<{
  fn: () => Promise<void>;
  children: (fn: () => Promise<void>) => React.ReactElement;
}> = ({ fn, children }) => {
  return children(useSetFormError(fn));
};

export const WithFormContext: React.FC<{
  children: (context: UseFormReturn) => JSX.Element | null;
}> = ({ children }) => {
  const methods = useFormContext();

  if (!children) {
    return null;
  }

  return children({
    ...methods,
  });
};
